import RxShoppingCart from "./RxShoppingCart";

export default RxShoppingCart;
